import * as Yup from "yup";

export const UpdateVersionSchema = Yup.object({
    andriod_version: Yup.string().required("Android Version Is Required"),
    ios_version: Yup.string().required("IOS Version Is Required"),
  


})